<template>
    <div v-if="isLoaded"
        id="appointment-app"
    >
        <VideoJitsi v-if="isVideoEnabled" :appointment_id="appointment_id" />
        <!--
        <template v-if="isVideoEnabled">
            <VideoJitsi v-if="isJitsi" :appointment_id="appointment_id" />
            <SessionVideo v-else
                :video-enabled="videoEnabled"
                :appointmentId="appointment_id"
            />
        </template>
        -->
        <SessionArchives v-if="appointment_id" :id="appointment_id" />
        <SessionChat v-if="isChatEnabled"
            :appointmentId="appointment_id"
            :timezone="timezone"
        />
    </div>
    <LoadingContainer v-else />
</template>

<script>
    import {mapGetters} from 'vuex';
    import { APPOINTMENT_VIDEO as VIDEO } from "../components/Config";
    import SessionArchives from "../components/SessionArchives";
    import SessionChat from "../components/SessionChat";
    // import SessionVideo from "../components/SessionVideo";
    import VideoJitsi from "@/components/VideoJitsi";

    import LoadingContainer from '@/components/loading/LoadingContainer';

    export default {
        name: "Session",

        data: function () {
            return {
                appointment_id: window.JS_APPOINTMENT_ID ,
            }
        },

        components: {
            LoadingContainer,
            SessionArchives,
            SessionChat,
            // SessionVideo,
            VideoJitsi,
        },
        computed: {
            videoEnabled() {
                return window.JS_VIDEO_ENABLED;
            },
            isVideoEnabled() {
                return window.JS_VIDEO_ENABLED > VIDEO.OFF;
            },
            isChatEnabled() {
                return window.JS_CHAT_ENABLED;
            },
            videoModeratorOnly() {
                return VIDEO.MODERATOR_ONLY == window.JS_VIDEO_ENABLED;
            },
            videoEveryone() {
                return VIDEO.EVERYONE == window.JS_VIDEO_ENABLED;
            },
            isJitsi() {
                return window.JS_IS_JITSI;
                // return this.getSetting('VIDEO_PROVIDER_JITSI');
            },
          ...mapGetters({
                isLoaded: 'isLoaded',
                getSetting: 'me/getSetting',
                timezone: "displayTZ",
          }),
        },
    }
</script>

<style>

</style>